import { ArrowLeft } from 'lucide-react';

const ProfileSkeleton = () => {
  return (
    <div className="min-h-screen gradient-mesh pb-4 lg:pb-8">
      <div className="sticky top-0 z-50 glass-strong border-b" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
        <div className="max-w-3xl mx-auto flex items-center gap-3 h-14 md:h-16 px-4 md:px-6">
          <div className="p-1.5"><ArrowLeft className="h-5 w-5 opacity-20" /></div>
          <div className="h-6 w-24 rounded-lg bg-secondary/50 shimmer-wrapper opacity-50" />
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 md:px-6 pt-6 md:pt-8 space-y-6 md:space-y-8">
        {/* Avatar + Name Skeleton */}
        <div className="flex items-center gap-4 md:gap-5">
          <div className="h-[72px] w-[72px] rounded-2xl bg-secondary/50 shimmer-wrapper shadow-card flex-shrink-0 opacity-40" />
          <div className="flex-1 space-y-2">
            <div className="h-7 w-40 rounded-lg bg-secondary/40 shimmer-wrapper opacity-50" />
            <div className="h-4 w-56 rounded-md bg-secondary/30 shimmer-wrapper opacity-30" />
          </div>
        </div>

        {/* Stats Grid Skeleton */}
        <div className="grid grid-cols-3 gap-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-[72px] rounded-2xl bg-card border border-border/50 shadow-card flex flex-col items-center justify-center gap-2">
              <div className="h-5 w-8 rounded bg-secondary/40 shimmer-wrapper opacity-40" />
              <div className="h-2 w-12 rounded bg-secondary/30 shimmer-wrapper opacity-20" />
            </div>
          ))}
        </div>

        {/* Menu Skeleton */}
        <div className="rounded-2xl bg-card shadow-card border border-border/50 divide-y overflow-hidden">
          {[1, 2, 3, 4, 5, 6, 7].map((i) => (
            <div key={i} className="px-5 flex items-center h-[56px] md:h-[60px] gap-4">
              <div className="h-5 w-5 rounded-lg bg-secondary/40 shimmer-wrapper flex-shrink-0 opacity-30" />
              <div className="h-4 w-32 rounded-lg bg-secondary/30 shimmer-wrapper opacity-40" />
              <div className="ml-auto h-4 w-4 rounded bg-secondary/20 shimmer-wrapper opacity-20" />
            </div>
          ))}
        </div>

        {/* Socials & Logout Skeleton */}
        <div className="space-y-6">
          <div className="space-y-3">
            <div className="h-3 w-20 rounded bg-secondary/30 shimmer-wrapper opacity-30 ml-1" />
            <div className="flex gap-3">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="h-11 w-11 rounded-2xl bg-card border border-border/50 shadow-card flex items-center justify-center">
                  <div className="h-5 w-5 rounded-full bg-secondary/30 shimmer-wrapper opacity-20" />
                </div>
              ))}
            </div>
          </div>

          <div className="h-11 w-full sm:w-32 rounded-2xl bg-secondary/30 shimmer-wrapper opacity-40 shadow-sm" />
        </div>
      </main>
    </div>
  );
};

export default ProfileSkeleton;
